import * as React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { DropDownArrow } from "../../../../template/CustomStyle";
import { customStyle } from '../../../../template/CustomStyle';

class Caracteristicas extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            attributeValuePublication: {},
        };
    }

    componentDidMount() {
        this.sincronizarAtributos(this.props);
    }


    componentDidUpdate(prevProps) {
        // Solo recalcular si cambiaron los elementos
        if (prevProps.attributePublication.elements !== this.props.attributePublication.elements) {
            this.sincronizarAtributos(this.props);
        }
    }

    sincronizarAtributos = (props) => {
        const { attributePublication } = props;

        if (attributePublication.elements && attributePublication.elements.length > 0) {

            let aVP = { ...this.state.attributeValuePublication };

            attributePublication.elements.forEach((atributo) => {
                aVP[atributo.attribute.id] = {
                    value: atributo.attributeValue.id,
                    label: atributo.attributeValue.name
                };
            });

            this.setState({ attributeValuePublication: aVP });
        }
    }




    setValue = (e, atributo) => {

        const elements = this.props.attributePublication.elements;

        if (elements && elements.length > 0) {
            // Encontrar el �ndice del atributo en los elementos
            const index = elements.findIndex((item) => item.idAttribute === atributo);

            if (index !== -1) {
                // Eliminar el atributo actual
                elements.splice(index, 1);
                // Actualizar con el nuevo valor
                //this.props.updateAttributeValue(e.target.value, atributo);
                this.props.attributePublication.elements.push({
                    idAttributeValue: e.value,
                    idAttribute: atributo,
                    attribute: { id: atributo },
                    attributeValue: { id: e.value, name: e.label }
                });
            } else {
                // Si el atributo no ten�a un valor, lo asignamos
                //this.props.updateAttributeValue(e.target.value, atributo);
                this.props.attributePublication.elements.push({
                    idAttributeValue: e.value,
                    idAttribute: atributo,
                    attribute: { id: atributo },
                    attributeValue: { id: e.value, name: e.label }
                });
            }
            debugger;
            let aVP = { ...this.state.attributeValuePublication };

            const matchedItem = this.props.attributePublication.elements.find((item) => item.idAttribute === atributo);

            if (matchedItem) {
                aVP[matchedItem.idAttribute] = { value: e.value, label: e.label };
                this.setState({ attributeValuePublication: aVP });
            }

        } else {
            // Si no hay elementos, asignar directamente el valor
            //this.props.updateAttributeValue(e.target.value, atributo);
        }

    };


    render() {
        return (
            <div className="tab-pane p-20 active" name="datos" id="home2" role="tabpanel">
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-6">
                        {
                            this.props.attributeCategories !== undefined && this.props.attributeCategories.elements !== null && this.props.attributeCategories.elements.length !== 0 &&
                            this.props.attributeCategories.elements.map((atributo) => {

                                // El Select funciona con el par value / label, por eso se formatean los datos
                                const attributeOptions = atributo.attribute.attributeValues.map((valor) => ({
                                    value: valor.id,
                                    label: valor.name
                                }));

                                return (
                                    <div className="row pb-2">
                                        <div className="col-sm-4 col-md-4 col-lg-4 pt-2">
                                            <label>{atributo.attribute.name}</label>
                                        </div>

                                        <div className="col-sm-8 col-md-8 col-lg-8">

                                            <Select
                                                name="caracteristicas"
                                                value={this.state.attributeValuePublication[atributo.attribute.id]}
                                                //value={this.setDefaultValue(atributo.attribute.id)}
                                                //value={attributeOptions.find((option) => option.value === this.setDefaultValue(atributo.attribute.id)) || null}
                                                styles={customStyle}
                                                components={{ DropdownIndicator: () => DropDownArrow }}
                                                className={"form-material"}
                                                options={attributeOptions}
                                                onChange={(e) => this.setValue(e, atributo.attribute.id)}

                                            />

                                        </div>
                                    </div>

                                );
                            })
                        }
                    </div>
                </div>
            </div>
        )

    }
}

const mapStateToProps = state => ({
    attributeCategories: state.publicaciones.attributeCategories,
    attributePublication: state.publicaciones.attributePublicacion,
});

export default connect(mapStateToProps)(Caracteristicas);